export default __webpack_public_path__ + "static/media/vessel_model_illustration.9b569af6.png";